import { UnitCost } from "./UnitCost";


export interface Unit {
    readonly cost: UnitCost;
    readonly name: string;
}


export namespace Unit {

    export function getAll(): Unit[] {
        return [
            {
                cost: UnitCost.cost590,
                name: "デスティニー",
            },
            {
                cost: UnitCost.cost590,
                name: "ストライクフリーダム",
            },
            {
                cost: UnitCost.cost590,
                name: "レジェンド",
            },
            {
                cost: UnitCost.cost590,
                name: "インフィニットジャスティス",
            },

            {
                cost: UnitCost.cost560,
                name: "アカツキ(オオワシ装備)",
            },
            {
                cost: UnitCost.cost560,
                name: "プロヴィデンス",
            },
            {
                cost: UnitCost.cost560,
                name: "フリーダム",
            },
            {
                cost: UnitCost.cost560,
                name: "ジャスティス",
            },
            {
                cost: UnitCost.cost560,
                name: "アカツキ(シラヌイ装備)",
            },

            {
                cost: UnitCost.cost450,
                name: "フォースインパルス",
            },
            {
                cost: UnitCost.cost450,
                name: "イージス",
            },
            {
                cost: UnitCost.cost450,
                name: "ソードインパルス",
            },
            {
                cost: UnitCost.cost450,
                name: "ブリッツ",
            },
            {
                cost: UnitCost.cost450,
                name: "ブラストインパルス",
            },
            {
                cost: UnitCost.cost450,
                name: "バスター",
            },
            {
                cost: UnitCost.cost450,
                name: "セイバー",
            },
            {
                cost: UnitCost.cost450,
                name: "デュエルAS",
            },
            {
                cost: UnitCost.cost450,
                name: "グフイグナイテッド(ハイネ機)",
            },
            {
                cost: UnitCost.cost450,
                name: "エールストライク",
            },
            {
                cost: UnitCost.cost450,
                name: "スラッシュザクファントム",
            },
            {
                cost: UnitCost.cost450,
                name: "ソードストライク",
            },
            {
                cost: UnitCost.cost450,
                name: "ブレイズザクファントム",
            },
            {
                cost: UnitCost.cost450,
                name: "ランチャーストライク",
            },
            {
                cost: UnitCost.cost450,
                name: "ガナーザクウォーリア(ルナマリア機)",
            },
            {
                cost: UnitCost.cost450,
                name: "ストライクノワール",
            },
            {
                cost: UnitCost.cost450,
                name: "ドムトルーパー",
            },
            {
                cost: UnitCost.cost450,
                name: "レイダー",
            },
            {
                cost: UnitCost.cost450,
                name: "ストライクルージュ",
            },
            {
                cost: UnitCost.cost450,
                name: "カラミティ",
            },
            {
                cost: UnitCost.cost450,
                name: "カオス",
            },
            {
                cost: UnitCost.cost450,
                name: "フォビドゥン",
            },
            {
                cost: UnitCost.cost450,
                name: "アビス",
            },
            {
                cost: UnitCost.cost450,
                name: "ガイア",
            },

            {
                cost: UnitCost.cost420,
                name: "グフイグナイテッド",
            },
            {
                cost: UnitCost.cost420,
                name: "デュエル",
            },
            {
                cost: UnitCost.cost420,
                name: "ザクウォーリア",
            },
            {
                cost: UnitCost.cost420,
                name: "ゲイツ[指揮官用]",
            },
            {
                cost: UnitCost.cost420,
                name: "ガナーザクウォーリア",
            },
            {
                cost: UnitCost.cost420,
                name: "シグー",
            },
            {
                cost: UnitCost.cost420,
                name: "ウィンダム(ネオ機)",
            },
            {
                cost: UnitCost.cost420,
                name: "ラゴゥ",
            },
            {
                cost: UnitCost.cost420,
                name: "ストライク(ビームライフル)",
            },
            {
                cost: UnitCost.cost420,
                name: "ストライク(バズーカ)",
            },
            {
                cost: UnitCost.cost420,
                name: "ムラサメ(バルトフェルド機)",
            },

            {
                cost: UnitCost.cost280,
                name: "バクゥ(ミサイルポッド)",
            },
            {
                cost: UnitCost.cost280,
                name: "ゾノ",
            },
            {
                cost: UnitCost.cost280,
                name: "バクゥ(レールキャノン)",
            },
            {
                cost: UnitCost.cost280,
                name: "ディン[指揮官用]",
            },
            {
                cost: UnitCost.cost280,
                name: "ゲイツR",
            },
            {
                cost: UnitCost.cost280,
                name: "ジン(大型ミサイル)",
            },
            {
                cost: UnitCost.cost280,
                name: "ジンハイマニューバ2型",
            },
            {
                cost: UnitCost.cost280,
                name: "ムラサメ",
            },
            {
                cost: UnitCost.cost280,
                name: "ウィンダム(ジェットストライカー)",
            },
            {
                cost: UnitCost.cost280,
                name: "ウィンダム(ミサイル)",
            },

            {
                cost: UnitCost.cost270,
                name: "バビ",
            },
            {
                cost: UnitCost.cost270,
                name: "ゲイツ",
            },
            {
                cost: UnitCost.cost270,
                name: "ディン",
            },
            {
                cost: UnitCost.cost270,
                name: "ジン(マシンガン)",
            },
            {
                cost: UnitCost.cost270,
                name: "長距離強行偵察複座型ジン",
            },
            {
                cost: UnitCost.cost270,
                name: "ジン(バズーカ)",
            },
            {
                cost: UnitCost.cost270,
                name: "アッシュ",
            },
            {
                cost: UnitCost.cost270,
                name: "ジン(特火重粒子砲)",
            },
            {
                cost: UnitCost.cost270,
                name: "ダガーL(ジェットストライカー)",
            },
            {
                cost: UnitCost.cost270,
                name: "M1アストレイ",
            },
            {
                cost: UnitCost.cost270,
                name: "ダガーL(キャノン砲)",
            },
            {
                cost: UnitCost.cost270,
                name: "ストライクダガー",
            },
            {
                cost: UnitCost.cost270,
                name: "ダークダガーL",
            },

            {
                cost: UnitCost.cost200,
                name: "グーン",
            },
            {
                cost: UnitCost.cost200,
                name: "ザウート",
            },
            {
                cost: UnitCost.cost200,
                name: "ジンオーカー",
            },
            {
                cost: UnitCost.cost200,
                name: "ジンワスプ",
            },
            {
                cost: UnitCost.cost200,
                name: "ガズウート",
            },
            {
                cost: UnitCost.cost200,
                name: "プロトジン",
            },
            {
                cost: UnitCost.cost200,
                name: "ザクウォーリア(ライブ仕様)",
            },
        ];
    }
}
